import React from 'react'
import FAQ1 from '../Component/faq/FAQ1'
import SEO from '../Component/SEO'
export default function FAQ() {
  return (
    <>
    <SEO
  title="FAQs | TROGO Transport Platform"
  description="Find answers to common questions about booking rides, payments, driver verification and safety on TROGO."
  keywords="trogo faq, transport booking help"
  url="https://www.togoodsdraft.com/faq"
/>

        <FAQ1/>
    </>
  )
}
